import {h, Component} from 'preact';
import invoke from 'lodash.invoke';
import Button from '@components/common/Button';

// Deals with paginating each result set individually
class SearchResultsPagination extends Component {
    static defaultProps = {
        showPagination: false,
        pageIndex: 0,
        resultPerPage: Infinity,
        results: []
    };

    constructor ( props ) {
        super( props );
        this.loadMore = this.loadMore.bind( this );

        this.state = {
            pageIndex: props.pageIndex || 0
        }
    }

    loadMore () {
        const {results, resultsPerPage} = this.props;
        const maxPageIndex = Math.ceil( results.length / resultsPerPage );
        const pageIndex = Math.min(
            Math.max( 0, this.state.pageIndex + 1 ),
            maxPageIndex - 1
        );
        this.setState( {pageIndex} );
    }

    getPagedResults ( results, countPerPage, pageIndex ) {
        return results.slice( 0, countPerPage * (pageIndex + 1) );
    }

    showPagination ( currentResultCount ) {
        const {results, showPagination} = this.props;
        return showPagination && (currentResultCount < results.length);
    }

    render ( props ) {
        const {groupIndex, results, resultsPerPage} = props;
        const pagedResults = this.getPagedResults( results, resultsPerPage, this.state.pageIndex );

        // send result updates back to Container in order to manage focus and item selections
        // from current result set properly
        invoke( this.props, 'onResultsChange',
            groupIndex,
            {
                results: pagedResults,
                resultCount: pagedResults.length
            }
        );

        if ( !pagedResults.length ) {
            return null;
        }

        return (
            <div>
                {props.children[0]( {pagedResults} )}
                {this.showPagination( pagedResults.length ) &&
                <div className="flex flex-col items-center mt-8" data-testid="pagination-summary">
                        <p className="text-xs uppercase txt-c2 tracking-wide">
                            Showing {pagedResults.length} of {results.length}
                        </p>
                        <Button className="mt-2" secondary onClick={this.loadMore}>{
                            (pagedResults.length + resultsPerPage < results.length)
                                ? `Next ${resultsPerPage} results`
                                : 'Remaining results'}
                        </Button>
                    </div>
                }
            </div>
        );
    }
}

export default SearchResultsPagination;
